
export enum WebBannerDataV1Action {
    "REGISTRATION_FORM" = "REGISTRATION_FORM",
    "URL" = "URL"
}
export type WebBannerDataV1 = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    action: WebBannerDataV1Action;
    /**
     * @type string | undefined
    */
    url?: string;
    /**
     * @type string
    */
    desktopImgUrl: string;
    /**
     * @type string
    */
    mobileImgUrl: string;
};
